import React, {Component} from 'react';
import {Checkbox} from 'semantic-ui-react';

class CheckboxField extends Component {
  render() {
    const {input, type, label, disabled} = this.props;
    return (
      <Checkbox
        toggle={type === 'toggle'}
        label={label}
        disabled={disabled}
        checked={!!input.value}
        onChange={(e, {checked}) => input.onChange(checked)}
      />
    );
  }
}

export default CheckboxField;
